import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Edit, Chat } from '@mui/icons-material';
import './EnvironmentSummary.css';

const EnvironmentSummary: React.FC = () => {
  const { tenantId, environmentId } = useParams<{ tenantId: string; environmentId: string }>();

  return (
    <div className="environment-summary">
      <h2>Environment Summary</h2>
      
      <div className="summary-actions">
        <Link 
          to={`/tenants/${tenantId}/environments/${environmentId}/edit`}
          className="action-button edit-button"
        >
          <Edit />
          Edit Environment
        </Link>
        
        <Link 
          to={`/tenants/${tenantId}/environments/${environmentId}/chat`}
          className="action-button chat-button"
        >
          <Chat />
          AI Assistant
        </Link>
      </div>
      
      <div className="summary-content">
        <p>Environment ID: {environmentId}</p>
        <p>Tenant ID: {tenantId}</p>
        {/* Add more summary content as needed */}
      </div>
    </div>
  );
};

export default EnvironmentSummary;